import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const SeasonBanner = () => {
  const { settings } = useSettings();
  if (!settings || !settings.season_enabled || !settings.season_message) return null;

  const label = settings.season_cta_label;
  const href = settings.season_cta_href || '/#contact';
  const isInternal = href.startsWith('/');

  const ctaClasses =
    'inline-flex items-center gap-2 bg-white text-emerald-700 hover:bg-emerald-50 font-semibold rounded-full px-5 py-2 text-sm transition-colors flex-shrink-0';

  return (
    <section
      className="bg-gradient-to-r from-emerald-600 to-cyan-600 text-white"
      data-testid="season-banner"
    >
      <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
        <div className="flex items-center gap-2.5">
          <Sparkles className="h-5 w-5 flex-shrink-0" />
          <p className="font-medium text-sm md:text-base" data-testid="season-message">
            {settings.season_message}
          </p>
        </div>
        {label &&
          (isInternal ? (
            <Link to={href} className={ctaClasses} data-testid="season-cta">
              {label} <ArrowRight className="h-4 w-4" />
            </Link>
          ) : (
            <a href={href} target="_blank" rel="noopener noreferrer" className={ctaClasses} data-testid="season-cta">
              {label} <ArrowRight className="h-4 w-4" />
            </a>
          ))}
      </div>
    </section>
  );
};

export default SeasonBanner;
